import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReactiveComponent } from '@app/shared/components/reactive-component';
import { FileChecker, RejectedFiles } from '@app/utils/file-checker';
import { ngValueAccessor } from '@app/utils/ng-value-accessor';

@Component({
  selector: 'portal-file-select',
  templateUrl: './file-select.component.html',
  styles: [],
  providers: [ngValueAccessor(FileSelectComponent)],
  standalone: false,
})
export class FileSelectComponent extends ReactiveComponent implements OnInit {
  @ViewChild('file', { static: true })
  file: ElementRef<HTMLInputElement>;

  @Input()
  accept: string = '*';

  @Input()
  btnClass: string;

  @Input()
  progressText: string;

  @Input()
  disabled: boolean = false;

  @Input()
  maxFileSize: number | null = null;

  @Input()
  progress: number;

  @Output()
  onFileChanged: EventEmitter<File> = new EventEmitter();

  hasFile: boolean = false;
  rejectedFiles: RejectedFiles | null = null;

  private fileChecker: FileChecker;

  ngOnInit(): void {
    this.fileChecker = new FileChecker({
      maxFileSize: this.maxFileSize,
    });
  }

  onButtonClicked() {
    this.file.nativeElement.click();
  }

  setFile(file: File) {
    const { acceptedFiles, rejectedFiles } = this.fileChecker.check([file]);

    if (acceptedFiles.length > 0) {
      this.onFileChanged.emit(acceptedFiles[0]);
      this.onTouched();
      this.onChange(acceptedFiles[0]);

      this.file.nativeElement.value = '';
      this.rejectedFiles = null;
    } else {
      this.rejectedFiles = {
        accept: this.accept,
        files: rejectedFiles,
        maxFileSize: this.maxFileSize,
      };
    }
  }

  writeValue(file: File | null): void {
    if (file != null) {
      this.setFile(file);
    }
  }
}
